import { CardRadio } from '@/components/ui/CardRadio'
import { DateInput } from '@/components/ui/DateInput'
import { Field, FieldLabel } from '@/components/ui/field'
import { PolicyChangeKind, RemovalReason } from '@/models/policyChange'
import { REMOVAL_REASONS } from './policyChangeCopy'

interface RemovalFieldsProps {
  kind: PolicyChangeKind
  reason: RemovalReason | undefined
  termLetter: Date | undefined
  lastLoad: Date | undefined
  onReason: (reason: RemovalReason) => void
  onTermLetter: (date: Date | undefined) => void
  onLastLoad: (date: Date | undefined) => void
}

/** Why a unit is leaving, for a vehicle, and the dates that say when. */
export function RemovalFields({
  kind,
  reason,
  termLetter,
  lastLoad,
  onReason,
  onTermLetter,
  onLastLoad,
}: RemovalFieldsProps) {
  return (
    <>
      {kind !== PolicyChangeKind.REMOVE_DRIVER && (
        <div className="flex flex-col gap-2">
          <div className="text-sm font-medium text-neutral-700">Why is it leaving?</div>
          <div className="grid grid-cols-2 gap-2">
            {REMOVAL_REASONS.map((option) => (
              <CardRadio
                key={option.value}
                isSelected={reason === option.value}
                onSelect={() => onReason(option.value)}
              >
                {option.label}
              </CardRadio>
            ))}
          </div>
        </div>
      )}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <Field>
          <FieldLabel htmlFor={`${kind}-term-letter`} optional>
            Termination letter date
          </FieldLabel>
          <DateInput value={termLetter} onChange={onTermLetter} inputProps={{ id: `${kind}-term-letter` }} />
        </Field>
        <Field>
          <FieldLabel htmlFor={`${kind}-last-load`} optional>
            Last load
          </FieldLabel>
          <DateInput value={lastLoad} onChange={onLastLoad} inputProps={{ id: `${kind}-last-load` }} />
        </Field>
      </div>
    </>
  )
}
